import { useEffect, useState } from "react";
import { localGetData, checkLocalStorageAge, localStoreData } from "../utils/utils";
import { LOCAL_STORAGE_KEYS } from "../Constants/localStorageKeys";
import { useLazyQuery } from "@apollo/client";
import { ALL_OFFICERS_QUERY } from "../Queries/AllOfficersQuery";

export const useFetchOfficers = (selectedOriId, onlineState) => {
  const [officers, setOfficers] = useState([]);

  const [getOfficers, { loading: officersLoading, error: officersError }] = useLazyQuery(ALL_OFFICERS_QUERY, {
    context: { serializationKey: "incidentQueue" },
    // onError: (error) => { console.error(JSON.stringify(error)) },
    onCompleted: (data) => {
      if (data) {
        localStoreData(data, LOCAL_STORAGE_KEYS.OFFICERS(selectedOriId));
        setOfficers(data.allOfficers); // Directly update officers state after fetch
      }
    }
  });

  useEffect(() => {
    if (selectedOriId) {
      const checkForOfficers = () => {
        // Only check age if online
        if (onlineState) {
          const isFresh = checkLocalStorageAge(LOCAL_STORAGE_KEYS.OFFICERS(selectedOriId), 8);

          if (!isFresh) {
            // Fetch new officers data when local storage is stale
            getOfficers({ variables: { oriIds: selectedOriId } });
          } else {
            // Use data from local storage if it's fresh
            setOfficers(localGetData(LOCAL_STORAGE_KEYS.OFFICERS(selectedOriId))?.allOfficers || []);
          }
        } else {
          // If offline, load data from local storage without clearing it
          setOfficers(localGetData(LOCAL_STORAGE_KEYS.OFFICERS(selectedOriId))?.allOfficers || []);
        }
      };

      if (selectedOriId) {
        checkForOfficers(); // Call checkForOfficers whenever selectedOriId or onlineState changes
      }
    } else {
      setOfficers([]); // Clear officers when selectedOriId is null
    }
  }, [selectedOriId, onlineState, getOfficers]);

  return { officers, officersLoading, officersError };
};
